import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const INTERVIEW_PROCESS_TYPE_TITLE = 'Interview';

const buildCreateSendoutInterviewAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(strings.sendoutsV2.alerts.submitMessages[severity].title, {
    processType: INTERVIEW_PROCESS_TYPE_TITLE,
    action: severity === 'success' ? 'Scheduled' : 'Scheduling'
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const createSendoutInterview = async ({ sendoutId, payload }) => {
  try {
    const response = await API.post(
      `${Endpoints.SendoutInterviews.replace(':id', sendoutId)}`,
      payload
    );

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildCreateSendoutInterviewAlert({
          severity: 'error',
          body: `Unexpected response status: ${response.status}`
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildCreateSendoutInterviewAlert({ severity: 'success' })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildCreateSendoutInterviewAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
